const defaultEnterprise = {};
const enterpriseAdmins = (state = defaultEnterprise, action) => {
  switch (action.type) {
    case 'GET_ENTERPRISE_ADMINS_SUCCESS':
      return { ...action.enterpriseAdmins };
    default:
      return state;
  }
};

export default enterpriseAdmins;
